import { Cancel, CancelTokenSource } from 'axios';
import {
  TCompanySearch,
  TMentorFinder,
  TRequestConsulting,
  TIntroductionQuestion,
  TAnnouncement,
  TInquirySubmit,
  TRecruitment,
  TAutoComplete,
} from 'modules/main';
import { TListRequestParams, TListResponse } from 'modules/types';
import apiClient from './apiClient';

/**
 * 회사탐색
 */
export const getCompanySearch = (id: number, cancel?: CancelTokenSource) => {
  return apiClient.get<TCompanySearch>(`/main/company_search/${id}`, {
    cancelToken: cancel?.token,
  });
};

export const getCompanySearchList = (cancel?: CancelTokenSource) => {
  return apiClient.get<Array<TCompanySearch>>(`/main/company_search_list`, {
    cancelToken: cancel?.token,
  });
};

/**
 * 수업신청
 */
export const consultingCreate = (params: TRequestConsulting, cancel?: CancelTokenSource) => {
  return apiClient.post('/main/request_consulting/create', params, {
    cancelToken: cancel?.token,
  });
};

/**
 * 멘토파인더
 */
export const mentorFinderCreate = (params: TMentorFinder, cancel?: CancelTokenSource) => {
  return apiClient.post('/main/mentor_finder/create', params, {
    cancelToken: cancel?.token,
  });
};

/**
 * 문의하기-자주묻는 질문
 */
export const getIntroductionQuestions = ({ params }: TListRequestParams, cancel?: CancelTokenSource) => {
  return apiClient.get<TListResponse<TIntroductionQuestion>>('/main/introduction_questions', {
    params: params,
    cancelToken: cancel?.token,
  });
};

export const getIntroductionQuestion = (id: number, cancel?: CancelTokenSource) => {
  return apiClient.get<TIntroductionQuestion>(`/main/introduction_question/${id}`, {
    cancelToken: cancel?.token,
  });
};

export const createIntroductionQuestion = (params: TIntroductionQuestion, cancel?: CancelTokenSource) => {
  return apiClient.post('/main/introduction_question/create', params, {
    cancelToken: cancel?.token,
  });
};

export const updateIntroductionQuestion = (
  id?: number,
  params?: TIntroductionQuestion,
  cancel?: CancelTokenSource,
) => {
  return apiClient.put(`/main/introduction_question/${id}`, params, {
    cancelToken: cancel?.token,
  });
};

export const deleteIntroductionQuestion = (id: number, cancel?: CancelTokenSource) => {
  return apiClient.delete(`/main/introduction_question/${id}`, {
    cancelToken: cancel?.token,
  });
};

/**
 * 공지사항
 */
export const getAnnouncements = ({ params }: TListRequestParams, cancel?: CancelTokenSource) => {
  return apiClient.get<TListResponse<TAnnouncement>>('/main/announcements', {
    params: params,
    cancelToken: cancel?.token,
  });
};

export const getAnnouncement = (id: number, cancel?: CancelTokenSource) => {
  return apiClient.get<TAnnouncement>(`/main/announcement/${id}`, {
    cancelToken: cancel?.token,
  });
};

export const createAnnouncement = (params: TAnnouncement, cancel?: CancelTokenSource) => {
  return apiClient.post('/main/announcement/create', params, {
    cancelToken: cancel?.token,
  });
};

export const updateAnnouncement = (id?: number, params?: TAnnouncement, cancel?: CancelTokenSource) => {
  return apiClient.put(`/main/announcement/${id}`, params, {
    cancelToken: cancel?.token,
  });
};

export const deleteAnnouncement = (id: number, cancel?: CancelTokenSource) => {
  return apiClient.delete(`/main/announcement/${id}`, {
    cancelToken: cancel?.token,
  });
};

/*
 * 1대1 문의
 */
export const inquirySubmit = (params: TInquirySubmit, cancel?: CancelTokenSource) => {
  return apiClient.post('/main/customer_Inquiry', params, {
    cancelToken: cancel?.token,
  });
};

/*
 * 채용공고
 */
export const getRecruitments = (
  category: string,
  { params }: TListRequestParams,
  cancel?: CancelTokenSource,
) => {
  return apiClient.get<TListResponse<TRecruitment>>(`/main/recruitments?category=${category}`, {
    params: params,
    cancelToken: cancel?.token,
  });
};

export const getRecruitment = (id: number, cancel?: CancelTokenSource) => {
  return apiClient.get<TRecruitment>(`/main/recruitment/${id}`, {
    cancelToken: cancel?.token,
  });
};

export const recruitmentCreate = (params: TRecruitment, cancel?: CancelTokenSource) => {
  return apiClient.post('/main/recruitment/create', params, {
    cancelToken: cancel?.token,
  });
};

/*
 * 자동완성
 */

export const autoCompleteCompanyName = ({ params }: TListRequestParams, cancel?: CancelTokenSource) => {
  return apiClient.get<TAutoComplete>(`/autocomplete/company_name`, {
    params: params,
    cancelToken: cancel?.token,
  });
};

export const autoCompletePositionName = ({ params }: TListRequestParams, cancel?: CancelTokenSource) => {
  return apiClient.get<TAutoComplete>(`/autocomplete/position_name`, {
    params: params,
    cancelToken: cancel?.token,
  });
};

export const autoCompleteUniversityName = ({ params }: TListRequestParams, cancel?: CancelTokenSource) => {
  return apiClient.get<TAutoComplete>(`/autocomplete/university_name`, {
    params: params,
    cancelToken: cancel?.token,
  });
};

export const autoCompleteMajorName = ({ params }: TListRequestParams, cancel?: CancelTokenSource) => {
  return apiClient.get<TAutoComplete>(`/autocomplete/major_name`, {
    params: params,
    cancelToken: cancel?.token,
  });
};
